import React from "react";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Grid,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { FaHome, FaFileAlt, FaPrint } from "react-icons/fa";
import { tokens } from "../../theme";
import { useTheme } from "@mui/material";

const menuItems = [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: <FaHome size={40} />,
    description: "Consolidado de consultas.",
  },
  {
    title: "Facturación Tarifa de Supervisión",
    path: "/tarifaSupervision",
    icon: <FaFileAlt size={40} />,
    description: `Genere su factura de servicios de tarifa por supervisión.`,
  },
  {
    title: "Consulta Avisos de Cobro",
    path: "/consultas",
    icon: <FaPrint size={40} />,
    description: `Consulte y descargue sus avisos de cobro.`,
  },
];

const HomeMenu = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box m={4}>
      <Grid container spacing={4}>
        {menuItems.map((item) => (
          <Grid item xs={12} sm={6} key={item.path}>
            <Card sx={{ display: "flex", minHeight: "150px", boxShadow: 3 }}>
              <Box
                sx={{
                  width: "8px",
                  backgroundColor: colors.gov[600],
                  borderRadius: "4px 0 0 4px",
                }}
              />
              <CardActionArea
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
                onClick={() => navigate(item.path)}
              >
                <Box
                  sx={{
                    padding: "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {item.icon}
                </Box>
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h5" component="div">
                    {item.title}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {item.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default HomeMenu;
